<template>
    <div class="bid_w_con">
        <span class="bid_title">예산을 선택해주세요</span>
        <ul class="bidding_seg_con">
            <li class="bidding_finance_item" :data-title="item[1]" @click="toggle_on_finance($event)" v-for="item in range.finance_range" >
                {{item[1]}}
            </li>
        </ul> 
        <div style="clear:both"></div> 
        <span class="bid_title">기간을 선택해주세요</span>
        <ul class="bidding_seg_con">
            <li class="bidding_period_item" :data-title="item[1]" @click="toggle_on_period($event)" v-for="item in range.period_range" >
                {{item[1]}}
            </li>
        </ul> 
        <div style="clear:both"></div> 
        <span class="bid_title">프로젝트 의뢰 마감일을 선택해주세요</span>
        <input type="text" id="datepicker1" v-model="end_at">       
    </div>
</template>
<script>
import EventBus from "@/EventBus.js";
export default {
    props:["range"],
    data(){
        return{
            end_at:"",
        }
    },    
    methods:{
        toggle_on_finance(e){
            $(".bidding_finance_item").removeClass("on")
            $(e.target).addClass("on")                        
            EventBus.$emit("select_finance_range",$(e.target).attr("data-title") )
        },
        toggle_on_period(e){
            $(".bidding_period_item").removeClass("on")
            $(e.target).addClass("on")                        
            EventBus.$emit("select_period_range",$(e.target).attr("data-title") )
        },
        
        prevStep(){EventBus.$emit("bidding_prev")},
        nextStep(){EventBus.$emit("bidding_next")},
    },
    mounted(){
  
        $("#datepicker1").datepicker({
            dateFormat: 'yy-mm-dd',
            prevText: '이전 달',
            nextText: '다음 달',
            monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
            monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
            dayNames: ['일', '월', '화', '수', '목', '금', '토'],
            dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
            dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
            showMonthAfterYear: true,
            yearSuffix: '년',
            onSelect: function(dateText){
                 EventBus.$emit("select_end_date", dateText )
            }
        });
    },
}
</script>
<style scoped lang="scss">
.bid_w_con{
    padding: 25px 50px;    
    .bid_title{
        font-size: 25px;
        font-weight: bold;
        color: #373737;
        line-height: 1;
        margin-bottom: 15px;
        margin-top: 15px;
        display: inline-block;
    }
    .bidding_seg_con{
        margin-top: 15px;
        border-top: 1px solid #e9e9e9;
        width: 700px;
        margin-left:50px;
        .bidding_finance_item,.bidding_period_item{
            display: list-item;
            color: #454545;
            cursor: pointer;
            width: 50%;
            box-sizing: border-box;
            float: left;
            border-right: 1px solid #e9e9e9;
            border-bottom: 1px solid #e9e9e9;
            font-size: 15px;
            text-align: left;       
            height: 55px;
            line-height: 55px;
            padding-left: 30px;
        }
        .bidding_finance_item:hover, .on , .bidding_period_item:hover, {
            background: #f27823;
            color: #fff;
        }
        .bidding_finance_item:nth-child(2n-1) , .bidding_period_item:nth-child(2n-1){
            border-left: 1px solid #e9e9e9;
        }        
    }
}
#datepicker1{
    border-radius: 5px;
    border: 1px solid #e9e9e9;
    padding: 3px 10px;
    width: 120px;
    margin-left: 30px;    
}
  .prev{
        display: inline-block;
        margin: 0 7px 0 0;
        padding: 0 5px;
        text-decoration: none;
        text-align: center;
        font-size: 13px;        
        color: #fff;
        outline-style: none;
        background-color: #f27824;
        border: 1px solid #f27824;
        line-height: 31px;       
        font-weight: bold;
        width: 71px;
        height: 31px;
        float: left;
        margin:30px;
        cursor: pointer;
    }
    .next{
        display: inline-block;
        margin: 0 7px 0 0;
        padding: 0 5px;
        text-decoration: none;
        text-align: center;
        font-size: 13px;        
        color: #fff;
        outline-style: none;
        background-color: #f27824;
        border: 1px solid #f27824;
        line-height: 31px;       
        font-weight: bold;
        width: 71px;
        height: 31px;
        float: right;
        margin: 30px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/SPA/Components/Bidding/BiddingRange.vue